import appImage from '../../../assets/app-image.png'

import './theApp.scss'

const TheApp = () => (
  <div className='the-app'>
    <div className='main-container'>
      <div className='title'>All the pieces of your world in one place</div>
      <img alt='Screenshot of the Everplans app on laptop and mobile devices' src={appImage} />
    </div>
  </div>
)

export default TheApp
